export default __webpack_public_path__ + "static/media/complementary--trucks-and-trailers--g1.67787aa2.png";